import { render, staticRenderFns } from "./connection-recman-api.vue?vue&type=template&id=585d38de&scoped=true&"
import script from "./connection-recman-api.ts?vue&type=script&lang=ts&"
export * from "./connection-recman-api.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585d38de",
  null
  
)

export default component.exports